import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr } from "date-fns/locale";
import moment from "moment";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";
import MDInput from "../../../components/MDInput";

import { maintenanceContractEnum } from "../../../config/enum";

export default function Contract({
  deviceId,
  maintenanceContract,
  setMaintenanceContract,
  signatureDate,
  setSignatureDate,
  informedDate,
  setInformedDate,
}) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            options={maintenanceContractEnum}
            value={maintenanceContract}
            required
            onChange={(event, newMaintenanceContract) => {
              setMaintenanceContract(newMaintenanceContract);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="État du contract de maintenance" variant="standard" />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <Stack component="form" noValidate>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
              <DatePicker
                slotProps={{ field: { clearable: true } }}
                displayWeekNumber
                label="Date de signature"
                value={signatureDate && new Date(signatureDate)}
                onChange={(newValue) => {
                  if (newValue === null) {
                    setSignatureDate(null);
                  } else setSignatureDate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
                format="dd/MM/yyyy"
              />
            </LocalizationProvider>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack component="form" noValidate>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
              <DatePicker
                slotProps={{ field: { clearable: true } }}
                displayWeekNumber
                label="Date de début de contrat"
                value={informedDate && new Date(informedDate)}
                onChange={(newValue) => {
                  if (newValue === null) {
                    setInformedDate(null);
                  } else setInformedDate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
                format="dd/MM/yyyy"
              />
            </LocalizationProvider>
          </Stack>
        </Grid>
      </Grid>
    </MDBox>
  );
}
